module.exports = __webpack_public_path__ + "img/5.320615c4.png";